import makePromise from './make-promise'

export default class OutlookNotifications {
  constructor(office) {
    this.office = office
  }

  get notificationMessages() {
    return this.office.context.mailbox.item.notificationMessages
  }

  add(...options) {
    return makePromise(
      this.notificationMessages.addAsync,
      this.notificationMessages
    )(...options).catch(() => {})
  }

  replace(...options) {
    return makePromise(
      this.notificationMessages.replaceAsync,
      this.notificationMessages
    )(...options).catch(() => {})
  }

  addError(key, message) {
    return this.add(key, { message, type: 'errorMessage' })
  }

  addInfo(key, message) {
    return this.add(key, {
      message,
      type: 'informationalMessage',
      persistent: false,
      icon: 'loft_icon16',
    })
  }

  async remove(...keys) {
    const removeWithPromise = makePromise(
      this.notificationMessages.removeAsync,
      this.notificationMessages
    )
    const promises = keys.map(key => removeWithPromise(key).catch(() => {}))
    await Promise.all(promises)
  }

  async removeAll() {
    const notifications = await makePromise(
      this.notificationMessages.getAllAsync,
      this.notificationMessages
    )()

    const keys = notifications.map(notification => notification.key)
    await this.remove(...keys)
  }

  startProgress(key, message) {
    return this.add(key, { message, type: 'progressIndicator' })
  }

  updateProgress(key, message) {
    return this.replace(key, { message, type: 'progressIndicator' })
  }
}
